var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { refetchAppointmentsThunk, refetchBookingsThunk } from '@spike/bookings-action';
import { alertErrorHandler, showSuccess } from '@spike/notifications-action';
import Axios from 'axios';
import { serialize } from 'object-to-formdata';
import { CLIENTS_CLEAR_ACTION_TYPE, CLIENTS_CLEAR_RETRIEVED_CLIENT_ACTION_TYPE, CLIENTS_DELETE_START_ACTION_TYPE, CLIENTS_DELETE_SUCCESS_ACTION_TYPE, CLIENTS_ERROR_ACTION_TYPE, CLIENTS_FETCH_ALL_START_ACTION_TYPE, CLIENTS_FETCH_ALL_SUCCESS_ACTION_TYPE, CLIENTS_FETCH_START_ACTION_TYPE, CLIENTS_FETCH_SUCCESS_ACTION_TYPE, CLIENTS_GET_START_ACTION_TYPE, CLIENTS_GET_SUCCESS_ACTION_TYPE, CLIENTS_RESET_ACTION_TYPE, CLIENTS_SAVE_AUTHORIZED_CONTACTS_START_ACTION_TYPE, CLIENTS_SAVE_AUTHORIZED_CONTACTS_SUCCESS_ACTION_TYPE, CLIENTS_SAVE_START_ACTION_TYPE, CLIENTS_SAVE_SUCCESS_ACTION_TYPE, CLIENTS_LOGICAL_DELETE_START_ACTION_TYPE, CLIENTS_LOGICAL_DELETE_SUCCESS_ACTION_TYPE, } from './ClientsActionsTypes';
import { convertToAuthorizedContactsDto, convertToClient, convertToSaveDto } from './ClientsConverter';
var clientsUrl = '/customers';
var clientUrl = '/customer';
var clientDetailUrl = '/customer_details';
var isFetchRequestToken = function (requestToken, state) {
    return state.clients.requestTokens.fetch === requestToken;
};
export var clearClientsThunk = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(clear());
            return [2 /*return*/];
        });
    }); };
};
export var clearRetrievedClientThunk = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(clearRetrievedClient());
            return [2 /*return*/];
        });
    }); };
};
export var fetchClientsThunk = function (apiClientWrapper, page, size, showInactivePets) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestToken, marketplaceId, url, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestToken = apiClientWrapper.uuid();
                    dispatch(fetchStart(requestToken));
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(clientsUrl, "?marketplace_id=").concat(marketplaceId, "&page=").concat(page !== null && page !== void 0 ? page : 1, "&size=").concat(size !== null && size !== void 0 ? size : 10);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isFetchRequestToken(requestToken, getState()) && dispatch(fetchSuccess(apiClientWrapper.masterData, apiClientWrapper.timeZone, response.data, showInactivePets));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!Axios.isCancel(apiError_1)) {
                        console.error({ apiError: apiError_1 });
                        dispatch(error());
                        alertErrorHandler(apiError_1, dispatch, 'Error fetching clients.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchAllClientsThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchAllStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(clientsUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchAllSuccess(apiClientWrapper.masterData, apiClientWrapper.timeZone, response.data));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    if (!Axios.isCancel(apiError_2)) {
                        console.error({ apiError: apiError_2 });
                        dispatch(error());
                        alertErrorHandler(apiError_2, dispatch, 'Error fetching all clients.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var searchClientsThunk = function (apiClientWrapper, searchText, page, size, showInactivePets) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestToken, marketplaceId, url, response, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestToken = apiClientWrapper.uuid();
                    dispatch(fetchStart(requestToken));
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(clientUrl, "/search?query=").concat(searchText, "&marketplace_id=").concat(marketplaceId, "&page=").concat(page, "&size=").concat(size);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isFetchRequestToken(requestToken, getState()) && dispatch(fetchSuccess(apiClientWrapper.masterData, apiClientWrapper.timeZone, response.data, showInactivePets));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _a.sent();
                    if (!Axios.isCancel(apiError_3)) {
                        console.error({ apiError: apiError_3 });
                        dispatch(error());
                        alertErrorHandler(apiError_3, dispatch, 'Error searching clients.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getClientThunk = function (apiClientWrapper, clientId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(clientDetailUrl, "/").concat(clientId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    if (!Axios.isCancel(apiError_4)) {
                        dispatch(error());
                        alertErrorHandler(apiError_4, dispatch, 'Error getting client.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveClientThunk = function (apiClientWrapper, client, showNotifications) {
    if (showNotifications === void 0) { showNotifications = true; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, apiClientMethod, saveUrl, actualClient, getUrl, getResponse, clientRequest, formData, options, response, apiError_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    apiClientMethod = client.id ? apiClientWrapper.apiClient.patch : apiClientWrapper.apiClient.post;
                    saveUrl = client.id
                        ? "".concat(clientsUrl, "/").concat(client.id, "?marketplace_id=").concat(marketplaceId)
                        : "".concat(clientsUrl, "?marketplace_id=").concat(marketplaceId);
                    if (!client.id) return [3 /*break*/, 2];
                    getUrl = "".concat(clientDetailUrl, "/").concat(client.id, "?marketplace_id=").concat(marketplaceId);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(getUrl, apiClientWrapper.requestConfig)];
                case 1:
                    getResponse = _a.sent();
                    actualClient = convertToClient(apiClientWrapper.masterData, apiClientWrapper.timeZone, getResponse.data);
                    _a.label = 2;
                case 2:
                    clientRequest = convertToSaveDto(apiClientWrapper.marketplaceId, client, actualClient);
                    formData = new FormData();
                    options = {
                        indices: false,
                        nullsAsUndefineds: false,
                        booleansAsIntegers: false,
                        allowEmptyArrays: true,
                    };
                    formData = serialize(clientRequest, options, formData, 'customer');
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, apiClientMethod(saveUrl, formData, apiClientWrapper.multipartRequestConfig)];
                case 4:
                    response = _a.sent();
                    dispatch(saveSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    dispatch(refetchAppointmentsThunk(apiClientWrapper));
                    dispatch(refetchBookingsThunk(apiClientWrapper));
                    if (showNotifications) {
                        dispatch(showSuccess('Update client successfully'));
                    }
                    return [3 /*break*/, 6];
                case 5:
                    apiError_5 = _a.sent();
                    if (!Axios.isCancel(apiError_5)) {
                        dispatch(error());
                        alertErrorHandler(apiError_5, dispatch, 'Error saving client.');
                    }
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
export var saveAuthorizedContactsThunk = function (apiClientWrapper, clientId, authorizedPeople) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, saveUrl, getUrl, getResponse, actualClient, formData, options, clientRequest, response, apiError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveAuthorizedContactsStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    saveUrl = "".concat(clientsUrl, "/").concat(clientId, "?marketplace_id=").concat(marketplaceId);
                    getUrl = "".concat(clientDetailUrl, "/").concat(clientId, "?marketplace_id=").concat(marketplaceId);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(getUrl, apiClientWrapper.requestConfig)];
                case 1:
                    getResponse = _a.sent();
                    actualClient = convertToClient(apiClientWrapper.masterData, apiClientWrapper.timeZone, getResponse.data);
                    formData = new FormData();
                    options = {
                        indices: false,
                        nullsAsUndefineds: false,
                        booleansAsIntegers: false,
                        allowEmptyArrays: false,
                    };
                    clientRequest = {
                        id: clientId,
                        authorized_contacts_attributes: convertToAuthorizedContactsDto(authorizedPeople, actualClient),
                    };
                    formData = serialize(clientRequest, options, formData, 'customer');
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(saveUrl, formData, apiClientWrapper.multipartRequestConfig)];
                case 3:
                    response = _a.sent();
                    dispatch(saveAuthorizedContactsSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    dispatch(showSuccess('Saved authorized contacts successfully'));
                    return [3 /*break*/, 5];
                case 4:
                    apiError_6 = _a.sent();
                    if (!Axios.isCancel(apiError_6)) {
                        dispatch(error());
                        alertErrorHandler(apiError_6, dispatch, 'Error saving authorized contacts.');
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteClientThunk = function (apiClientWrapper, clientId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, marketplaceId, url, response, apiError_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    formData = new FormData();
                    dispatch(deleteStart());
                    formData.append('customer[deleted]', 'true');
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(clientsUrl, "/").concat(clientId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, formData, apiClientWrapper.multipartRequestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(deleteSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    dispatch(showSuccess('Client deleted'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_7 = _a.sent();
                    if (!Axios.isCancel(apiError_7)) {
                        dispatch(error());
                        alertErrorHandler(apiError_7, dispatch, 'Error deleting client.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var logicalDeleteClientThunk = function (apiClientWrapper, clientId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, deleteUrl, body, response, apiError_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(logicalDeleteClientStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    deleteUrl = "".concat(clientsUrl, "/").concat(clientId, "/logical_delete?marketplace_id=").concat(marketplaceId);
                    body = {
                        "customer": {
                            "deleted": true
                        }
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(deleteUrl, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(logicalDeleteClientSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    dispatch(showSuccess('Client deleted'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_8 = _a.sent();
                    if (!Axios.isCancel(apiError_8)) {
                        dispatch(error());
                        alertErrorHandler(apiError_8, dispatch, 'Error deleting client.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var reset = function () {
    return {
        type: CLIENTS_RESET_ACTION_TYPE,
    };
};
var clear = function () {
    return {
        type: CLIENTS_CLEAR_ACTION_TYPE,
    };
};
var clearRetrievedClient = function () {
    return {
        type: CLIENTS_CLEAR_RETRIEVED_CLIENT_ACTION_TYPE,
    };
};
var fetchStart = function (requestToken) {
    return {
        type: CLIENTS_FETCH_START_ACTION_TYPE,
        payload: { requestToken: requestToken },
    };
};
var fetchSuccess = function (masterData, timeZone, client, showInactivePets) {
    return {
        type: CLIENTS_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            clients: client.customers.map(function (clientDto) { return convertToClient(masterData, timeZone, clientDto, showInactivePets); }),
            page: client.page,
            size: client.size,
            total_pages: client.total_pages,
            total_records: client.total_records,
        },
    };
};
var fetchAllStart = function () {
    return {
        type: CLIENTS_FETCH_ALL_START_ACTION_TYPE
    };
};
var fetchAllSuccess = function (masterData, timeZone, clientDtos) {
    return {
        type: CLIENTS_FETCH_ALL_SUCCESS_ACTION_TYPE,
        payload: {
            clients: clientDtos.map(function (clientDto) { return convertToClient(masterData, timeZone, clientDto, true); }),
        },
    };
};
var getStart = function () {
    return {
        type: CLIENTS_GET_START_ACTION_TYPE,
    };
};
var getSuccess = function (clientDto, masterData, timeZone) {
    return {
        type: CLIENTS_GET_SUCCESS_ACTION_TYPE,
        payload: {
            client: convertToClient(masterData, timeZone, clientDto, true),
        },
    };
};
var saveStart = function () {
    return {
        type: CLIENTS_SAVE_START_ACTION_TYPE,
    };
};
var saveSuccess = function (clientDto, masterData, timeZone) {
    return {
        type: CLIENTS_SAVE_SUCCESS_ACTION_TYPE,
        payload: {
            client: convertToClient(masterData, timeZone, clientDto),
        },
    };
};
var saveAuthorizedContactsStart = function () {
    return {
        type: CLIENTS_SAVE_AUTHORIZED_CONTACTS_START_ACTION_TYPE,
    };
};
var saveAuthorizedContactsSuccess = function (clientDto, masterData, timeZone) {
    return {
        type: CLIENTS_SAVE_AUTHORIZED_CONTACTS_SUCCESS_ACTION_TYPE,
        payload: {
            client: convertToClient(masterData, timeZone, clientDto),
        },
    };
};
var deleteStart = function () {
    return {
        type: CLIENTS_DELETE_START_ACTION_TYPE,
    };
};
var deleteSuccess = function (clientDto, masterData, timeZone) {
    return {
        type: CLIENTS_DELETE_SUCCESS_ACTION_TYPE,
        payload: {
            client: convertToClient(masterData, timeZone, clientDto),
        },
    };
};
var logicalDeleteClientStart = function () {
    return {
        type: CLIENTS_LOGICAL_DELETE_START_ACTION_TYPE,
    };
};
var logicalDeleteClientSuccess = function (clientDto, masterData, timeZone) {
    return {
        type: CLIENTS_LOGICAL_DELETE_SUCCESS_ACTION_TYPE,
        payload: {
            client: convertToClient(masterData, timeZone, clientDto),
        },
    };
};
var error = function () {
    return {
        type: CLIENTS_ERROR_ACTION_TYPE,
    };
};
